exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-document-file-previewer--component-wrapper[data-v-ecdb2854] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-left: 10px;\n}\n.sign-document-file-previewer--component-wrapper[data-v-ecdb2854]:empty {\n    padding-left: 0;\n}\n", ""]);

// exports
